'use client';

import clsx from 'clsx';
import Logo from '../ui/Logo';
import QrCode from '../ui/QrCode';
import { getGameShareUrl } from '@/src/utils/shareGameLink';
import { appendRefIdToUrl } from '@/src/utils/refIdShareParam';

export default function DesktopWarning() {

    return (
        <div className='z-200 absolute inset-0 flex flex-col justify-center items-center gap-6 bg-gradient-light-radial p-6 w-svw h-svh text-center'>
            <img src='/images/KeyvizDesktop.png' className='absolute inset-0 w-full h-full object-cover' />
            <div className='absolute inset-0 flex flex-col justify-between items-center px-4 py-6 bg-vignette'>
                <Logo variant='stacked' />
                <div
                    className={clsx(
                        'flex bg-white-gradient border-white-stroke w-full pattern-background items-center justify-center drop-shadow-2-white-stroke',
                        'gap-3 p-4 border rounded-3xl max-w-90',
                        'stele:rounded-[96px] stele:gap-12 stele:p-16'
                    )}>
                    <svg width='50' height='50' viewBox='0 0 34 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <rect x='2' y='2' width='30' height='46' rx='6' stroke='url(#paint0_linear_6844_13080)' strokeWidth='4' />
                        <rect x='12' y='6' width='10' height='4' rx='2' fill='url(#paint1_linear_6844_13080)' />
                        <defs>
                            <linearGradient id='paint0_linear_6844_13080' x1='17' y1='50' x2='17' y2='-5.55432e-08' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='#06487C' />
                                <stop offset='1' stopColor='#06487C' />
                            </linearGradient>
                            <linearGradient id='paint1_linear_6844_13080' x1='17' y1='10' x2='17' y2='6' gradientUnits='userSpaceOnUse'>
                                <stop stopColor='#06487C' />
                                <stop offset='1' stopColor='#06487C' />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div className='flex flex-col items-start justify-center text-left gap-2'>
                        <p className='font-grandstander font-bold text-[16px] text-white-stroke-even-darker italic leading-[100%] tracking-[0%]'>AUF DEM SMARTPHONE MACHT’S AM MEISTEN SPASS!</p>
                        <p className='font-nunito text-[12px] text-white-stroke-even-darker leading-[135%] tracking-[0%] whitespace-nowrap'>QR-Code scannen und loslaufen!</p>
                    </div>
                    <div className='border-2 border-white rounded-lg p-1 bg-white'>
                        <QrCode
                            value={appendRefIdToUrl(getGameShareUrl())}
                            size={75}
                            color='#06487C'
                            background='#FFFFFF'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
